import { getConfig } from '../../utils/config';

const configColors = getConfig().theme.colors;

export const colors = {
  // --- Legacy / Flat Colors (Para retrocompatibilidade) ---
  brandYellow: configColors.yellow || '#f2c01a',
  brandDarkBlue: configColors.darkBlue || '#006b9c',
  brandLightBlue: configColors.lightBlue || '#00a9ff',
  brandIce: configColors.lightBlue2 || '#eaf9fc',
  brandOffWhite: configColors.light || '#f5f5f5',
  brandLightGray: configColors.lightCyan || '#c0ccd0',
  brandMediumGray: configColors.lightDark || '#8e9da2',
  primary: configColors.primary || '#006b9c',
  secondary: configColors.secondary || '#00a9ff',
  tertiary: configColors.warn || '#f2c01a',
  success: configColors.success || '#28a745',
  warning: configColors.warn || '#ffc107',
  warn: configColors.warn || '#ffc107',
  error: configColors.danger || '#dc3545',
  info: configColors.info || '#17a2b8',
  light: configColors.light || '#f5f5f5',
  dark: configColors.dark || '#091b26',
  link: configColors.primaryVariant || '#00a9ff',

  // --- Nova Estrutura Semântica (Design System) ---
  brand: {
    primary: configColors.primary || '#006b9c',
    primaryHover: configColors.darkBlue || '#005b85',
    secondary: configColors.secondary || '#00a9ff'
  },
  surface: {
    background: configColors.light || '#f5f5f5',
    card: '#ffffff',
    overlay: 'rgba(0, 0, 0, 0.5)'
  },
  text: {
    primary: configColors.dark || '#091b26',
    secondary: configColors.lightDark || '#8e9da2',
    muted: configColors.lightCyan || '#c0ccd0',
    inverse: '#ffffff'
  },
  border: {
    default: '#e0e0e0',
    focus: configColors.primary || '#006b9c'
  },
  feedback: {
    success: configColors.success || '#28a745',
    error: configColors.danger || '#dc3545',
    warning: configColors.warn || '#ffc107',
    info: configColors.info || '#17a2b8'
  }
};



// WEBPACK FOOTER //
// ./src/design-system/theme/colors.js